import { Assistant, Connection, Namespace } from '@vendasta/protos/ai_assistants/v1alpha1';

export const MY_LISTING_CONNECTION_NAME = 'My Listing Chat Widget';
export const WEBCHAT_CONNECTION_NAME = 'Web Chat';

export enum ConnectionType {
  WebchatWidget = 'WebchatWidget',
  SnapshotWidget = 'SnapshotWidget',
  SMS = 'SMS',
  SocialMarketing = 'SocialMarketing',
  System = 'System',
  Unspecified = 'Unspecified',
  Voice = 'Voice',
  WhatsApp = 'WhatsApp',
  Instagram = 'Instagram',
  Facebook = 'Facebook',
  Email = 'Email',
  AutoReviewResponse = 'AutoReviewResponse',
  Platform = 'Platform',
}

export interface NamespaceConfig {
  namespace: Namespace;
  root?: string;
}

export interface AiAssistant {
  assistant: Partial<Assistant>;
  subtitleKey?: string;
  descriptionKey?: string;
  decoration?: AiAssistantDecoration;
  connections?: AiConnection[];
  isDefault?: boolean;
  showConfigButtonOnDefault?: boolean;
  isDisabled?: boolean;
  isComingSoon?: boolean;
  cta?: CTAction;
  computeCTA?: (assistant: AiAssistant) => CTAction;
  alertInformation?: string;
  hideConnections?: boolean;
  autonomyRating?: number;
  order?: number;
  showManageTriggersButton?: boolean;
}

export interface AiConnection {
  connection: Partial<Connection>;
  isDefault?: boolean;
  cta?: CTAction;
}

export interface AiAssistantDecoration {
  defaultAvatarIcon?: string;
  gradientColor?: string;
  avatarIconUrl?: string;
}

export type Action = ActionWithUrl | ActionWithPath | ActionWithCallback;

export interface CTAction {
  label?: string;
  action?: Action;
}

interface ActionBase {
  showButton?: boolean;
  disabled?: boolean;
}

export interface ActionWithUrl extends ActionBase {
  url: string;
  relativeRoute?: boolean;
  newTab?: boolean;
  queryParams?: Record<string, string>;
  pathCommands?: never;
  callback?: never;
}

export interface ActionWithPath extends ActionBase {
  url?: never;
  relativeRoute?: boolean;
  newTab?: never;
  queryParams?: never;
  pathCommands: unknown[];
  callback?: never;
}

export interface ActionWithCallback extends ActionBase {
  url?: never;
  relativeRoute?: never;
  newTab?: never;
  queryParams?: never;
  pathCommands?: never;
  callback: () => void;
}
